import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "mt-4 flow-root" }
const _hoisted_3 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_4 = { class: "inline-block min-w-full align-middle" }
const _hoisted_5 = { class: "min-w-full" }
const _hoisted_6 = {
  scope: "col",
  class: "py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_8 = {
  scope: "col",
  class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_11 = { class: "divide-y border-spacing-2 divide-gray-100 bg-white rounded-lg shadow-sm" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  colspan: "5",
  class: "rounded-lg"
}
const _hoisted_14 = { class: "w-full p-8 flex justify-center items-center" }
const _hoisted_15 = { class: "text-sm text-gray-500" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "size-11 shrink-0" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "ml-4" }
const _hoisted_21 = { class: "font-medium text-gray-900" }
const _hoisted_22 = {
  key: 0,
  class: "mt-1 text-gray-500"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "text-gray-500" }
const _hoisted_26 = {
  key: 0,
  class: "flex overflow-hidden ml-3"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "text-gray-900" }
const _hoisted_30 = { class: "mt-1 text-gray-500" }
const _hoisted_31 = {
  key: 1,
  class: "text-gray-900"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "flex items-center space-x-2 justify-end" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "hidden sm:block" }
const _hoisted_38 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('gallery_list.name')), 1),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('gallery_list.photos')), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('gallery_list.storage')), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('gallery_list.downloads')), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('gallery_list.views')), 1),
                _cache[0] || (_cache[0] = _createElementVNode("th", {
                  scope: "col",
                  class: "relative py-3.5 pr-4 pl-3"
                }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_11, [
              (_ctx.isSearchEmpty)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('gallery_list.not_found')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleries, (gallery, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "cursor-pointer hover:shadow-xs hover:bg-gray-50 rounded-lg group",
                  key: `gallery-list-item-${gallery.slug}`
                }, [
                  _createElementVNode("td", {
                    onClick: _withModifiers(($event: any) => (_ctx.routeToGallery(gallery.slug)), ["prevent"]),
                    class: _normalizeClass({'py-5 pr-3 pl-4 text-sm whitespace-nowrap': true, 'rounded-tl-lg': index === 0, 'rounded-bl-lg': index === _ctx.galleries.length - 1})
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("img", {
                          class: "size-11 rounded-full object-cover",
                          src: gallery.small_cover_url,
                          alt: gallery.name
                        }, null, 8, _hoisted_19)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(gallery.name), 1),
                        (gallery.date)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(gallery.date), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 10, _hoisted_16),
                  _createElementVNode("td", {
                    onClick: _withModifiers(($event: any) => (_ctx.routeToGallery(gallery.slug, true)), ["prevent"]),
                    class: "px-3 py-5 text-sm whitespace-nowrap text-gray-500"
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(gallery.photos_count) + " " + _toDisplayString(_ctx.$t('gallery_list.files_count')), 1),
                      (gallery.photos.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gallery.photos, (item) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: `gallery-photo-item-${gallery.id}-${item.id}`,
                                class: "inline-block size-8 rounded-full ring-2 ring-white object-cover",
                                src: item.url,
                                alt: ""
                              }, null, 8, _hoisted_27))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_23),
                  _createElementVNode("td", {
                    onClick: _withModifiers(($event: any) => (_ctx.routeToGallery(gallery.slug)), ["prevent"]),
                    class: "px-3 py-5 text-sm whitespace-nowrap text-gray-500"
                  }, [
                    (gallery.storage_to_date)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('gallery_item.storage_to')) + ":", 1),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(gallery.storage_to_date), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t('gallery_item.storage_without_limit')), 1))
                  ], 8, _hoisted_28),
                  _createElementVNode("td", {
                    onClick: _withModifiers(($event: any) => (_ctx.routeToGallery(gallery.slug)), ["prevent"]),
                    class: "px-3 py-5 text-sm whitespace-nowrap text-gray-500"
                  }, _toDisplayString(gallery.downloads_count), 9, _hoisted_32),
                  _createElementVNode("td", {
                    onClick: _withModifiers(($event: any) => (_ctx.routeToGallery(gallery.slug)), ["prevent"]),
                    class: "px-3 py-5 text-sm whitespace-nowrap text-gray-500"
                  }, _toDisplayString(gallery.views_count), 9, _hoisted_33),
                  _createElementVNode("td", {
                    class: _normalizeClass({'relative py-5 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap': true, 'rounded-tr-lg': index === 0, 'rounded-br-lg': index === _ctx.galleries.length - 1})
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.isDeleting)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (_ctx.restoreGallery(gallery.slug)), ["prevent"]),
                            class: "bg-blue-500 text-white py-2 px-3 rounded text-sm hover:bg-blue-600 focus:outline-none cursor-pointer"
                          }, _toDisplayString(_ctx.$t('gallery_item.restore')), 9, _hoisted_35))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (_ctx.deleteGallery(gallery.slug)), ["prevent"]),
                        class: _normalizeClass({'bg-red-500 text-white p-2.5 px-3 sm:py-2 rounded text-sm hover:bg-red-600 focus:outline-none cursor-pointer flex items-center gap-1': true, 'sm:opacity-0 group-hover:opacity-100': !_ctx.isDeleting})
                      }, [
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('gallery_item.delete')), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          "stroke-width": "1.5",
                          stroke: "currentColor",
                          class: "size-4"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                          })
                        ], -1))
                      ], 10, _hoisted_36),
                      (!_ctx.isDeleting)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _withModifiers(($event: any) => (gallery.is_pinned ? _ctx.unpinGallery(gallery.slug) : _ctx.pinGallery(gallery.slug)), ["prevent"]),
                            class: _normalizeClass({'p-2.5 rounded text-sm focus:outline-none cursor-pointer outline-1 outline-gray-200': true, 'bg-gray-100 text-gray-100 stroke-gray-500 hover:bg-gray-200 sm:opacity-0 group-hover:opacity-100': !gallery.is_pinned, 'bg-white stroke-gray-500 text-gray-500 hover:bg-gray-100': gallery.is_pinned})
                          }, _cache[2] || (_cache[2] = [
                            _createElementVNode("svg", {
                              class: "shrink-0 size-4",
                              viewBox: "0 0 18 18",
                              fill: "currentColor",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", { d: "M4.27851 7.18016C3.72241 7.25256 3.44436 7.28876 3.38422 7.46551C3.32408 7.64226 3.51876 7.83694 3.90812 8.2263L9.64966 13.9678C10.0836 14.4018 10.3006 14.6188 10.4829 14.5481C10.6653 14.4774 10.6795 14.1648 10.7081 13.5396C10.8811 9.75464 11.915 8.1738 14.5139 7.06964C14.918 6.89797 15.12 6.81213 15.1504 6.65558C15.1808 6.49902 15.0312 6.34937 14.7319 6.05008L11.4597 2.77784C11.1238 2.44201 10.9559 2.2741 10.7919 2.31418C10.6279 2.35426 10.5531 2.5912 10.4034 3.06507C9.59426 5.62654 8.03961 6.69049 4.27851 7.18016Z" }),
                              _createElementVNode("path", { d: "M2.64645 14.6464C2.45118 14.8417 2.45118 15.1583 2.64645 15.3536C2.84171 15.5488 3.15829 15.5488 3.35355 15.3536L2.64645 14.6464ZM7 11L6.64645 10.6464L2.64645 14.6464L3 15L3.35355 15.3536L7.35355 11.3536L7 11Z" })
                            ], -1)
                          ]), 10, _hoisted_38))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}